/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 01.06.17.
 */

/*
Creates registry of resources.
Each resource should be presented with thi following files in this directory:

* {resource}.json - resource Json Schema file
* {resource}-{type}.json - resource JsonUI Schema file for specified {type}. Type can be one of:
    * list - used for showing resource list
    * search - used for showing resource search form
    * view - used for showing resource view
    * edit - used for showing resource edit form
    * new - used for showing new resource edit form
    * delete - used for showing resource delete message
 */
let req = require.context("./", true, /\.json$/);
let resources = {};
req.keys().forEach(function (key) {
    let value = req(key);
    let match = key.match(/^\.\/(.*)\.json$/);
    if (match && match[1]) {
        let filenameParts = match[1].split("-");
        if (filenameParts.length > 2) {
            let resource = filenameParts.shift();
            let type = filenameParts.shift();
            type += "-" + filenameParts.join("-");
            filenameParts = [resource, type];
        }
        if (!resources[filenameParts[0]]) resources[filenameParts[0]] = {};
        if (filenameParts.length > 1) resources[filenameParts[0]][filenameParts[1]] = value;
        else resources[filenameParts[0]]["schema"] = value;
    }
});

export default resources;
